import { render, staticRenderFns } from "./Area6.vue?vue&type=template&id=df8a355c&scoped=true&"
import script from "./Area6.vue?vue&type=script&lang=js&"
export * from "./Area6.vue?vue&type=script&lang=js&"
import style0 from "./Area6.vue?vue&type=style&index=0&id=df8a355c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8a355c",
  null
  
)

export default component.exports